import {CardProperty} from './CardProperty'
import {Box, Chip, Grid2 as Grid} from '@mui/material'
import {ReactNode} from 'react'
import {FormattedMessage} from 'react-intl'
import {Translation, useTranslatedText} from '@enisco/mcc-react-lib'

export interface LicensePropertyProps {
  name: string
  translation?: Translation
  value: unknown
  usage: unknown
}

interface ArrayElement {
  value: ReactNode
  inUse: boolean
}

export const LicenseProperty = (props: LicensePropertyProps) => {
  const label = useTranslatedText(props.translation)

  if (Array.isArray(props.value)) {
    const usageArray = Array.isArray(props.usage) ? props.usage : []
    const elements: ArrayElement[] = props.value.map((value) => {
      return {
        value: value?.toString() ?? '-',
        inUse: usageArray.includes(value)
      }
    })

    return (
      <CardProperty label={label || props.name}>
        <Grid container columns={1} spacing={1}>
          {elements.map((element) => (
            <Grid size={1}>
              <Box display={'inline'} sx={{pr: 1}}>
                {element.value}
              </Box>
              {element.inUse ? (
                <Chip
                  label={
                    <FormattedMessage
                      id={'LicenseDialog.Property.InUse'}
                      defaultMessage='In use'
                    />
                  }
                  variant={'filled'}
                  color={'success'}
                  size={'small'}
                ></Chip>
              ) : (
                <Chip
                  label={
                    <FormattedMessage
                      id={'LicenseDialog.Property.NotInUse'}
                      defaultMessage='Not in use'
                    />
                  }
                  variant={'filled'}
                  color={'default'}
                  size={'small'}
                ></Chip>
              )}
            </Grid>
          ))}
        </Grid>
      </CardProperty>
    )
  }

  let displayValue = props.value?.toString() ?? '-'

  if (props.usage && !isNaN(Number(props.usage))) {
    displayValue = `${props.usage} / ${props.value?.toString() ?? '-'}`
  }

  return (
    <CardProperty label={label || props.name}>
      <Box display={'inline'} sx={{pr: 1}}>
        {displayValue}
      </Box>
      {typeof props.usage === 'string' && (
        <Chip label={props.usage?.toString()} size={'small'} />
      )}
    </CardProperty>
  )
}
